module.exports = __webpack_public_path__ + "vue/img/lock2.8fd1d6aa.png";